import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';
import Kontaktizleti  from './kontaktizleti.js';

import { useTranslation } from 'react-i18next';

const Zadar = (props) => {

const { t } = useTranslation();

  return (
  	<div>
      
            <div className="container"> 
            <div>
              <img className="logo" src="slike/logo.png" alt="logo"/>
          </div>
              <div id="carouselExampleIndicators" className="carousel slide " data-ride="carousel">
                <ol className="carousel-indicators">
                  <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img className="d-block w-100" src="slike/izleti/izleti/zadar1.jpg" alt="First slide"/>
                  </div>
                  <div className="carousel-item">
                    <img className="d-block w-100" src="slike/izleti/izleti/zadar2.jpg" alt="Second slide"/>
                  </div>
                  <div className="carousel-item">
                    <img className="d-block w-100" src="slike/izleti/izleti/zadar3.jpg" alt="Third slide"/>
                  </div>
                </div>
                <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="sr-only"></span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="sr-only"></span>
                </a>
              </div>
              <div className="text">
                <h2 className="h2izlet">{ t('zadar.zadar-title') }</h2>
                <div>
                  <Button id="opcenito" className="morebtn" >{ t('zadar.zadar-Overview-title') }</Button>
                    <UncontrolledCollapse toggler="#opcenito">
                      <Card>
                        <CardBody>
                          <p>{ t('zadar.zadar-Overview-text') }</p>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                  </div>
                <hr className="line"/>
                <div>
                  <Button id="ukljuceno" className="morebtn">{ t('zadar.zadar-title-2') }</Button>
                    <UncontrolledCollapse toggler="#ukljuceno">
                      <Card>
                        <CardBody>
                <ul>
                  <li>{ t('zadar.zadar-list-1') }</li>
                  <li>{ t('zadar.zadar-list-2') }</li>
                  <li>{ t('zadar.zadar-list-3') }</li>
                  <li>{ t('zadar.zadar-list-4') }</li>
                  <li>{ t('zadar.zadar-list-5') }</li>
                  <li>{ t('zadar.zadar-list-6') }</li>
                  <li>{ t('zadar.zadar-list-7') }</li>
                  <li>{ t('zadar.zadar-list-8') }</li>
                </ul>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>
                <div>
                  <Button id="odlazak" className="morebtn">{ t('zadar.zadar-title-3') }</Button>
                    <UncontrolledCollapse toggler="#odlazak">
                      <Card>
                        <CardBody>
                          <p>{ t('zadar.zadar-text-2') }</p>
                          </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <div>
                  <Button id="ulaznica" className="morebtn">{ t('zadar.zadar-title-4') }</Button>
                    <UncontrolledCollapse toggler="#ulaznica">
                      <Card>
                        <CardBody>
                          <p>
                          { t('zadar.zadar-price-list-1') }
                          </p>
                          <ul>
                            <li>{ t('zadar.zadar-price-list-2') }</li>
                            <li>{ t('zadar.zadar-price-list-3') }</li>
                          </ul>
                          
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <div>
                  <Button id="itinerar" className="morebtn">{ t('zadar.zadar-title-5') }</Button>
                    <UncontrolledCollapse toggler="#itinerar">
                      <Card>
                        <CardBody>
                          <p>{ t('zadar.zadar-itinerar-txt-1') }</p>
                          <p>{ t('zadar.zadar-itinerar-txt-2') }</p>
                          <p>{ t('zadar.zadar-itinerar-txt-3') }</p>
                          <p>{ t('zadar.zadar-itinerar-txt-4') }</p>
                          <p>{ t('zadar.zadar-itinerar-txt-5') }</p>
                          <p>{ t('zadar.zadar-itinerar-txt-6') }</p>
                          <p>{ t('zadar.zadar-itinerar-txt-7') }</p>
                          <p>{ t('zadar.zadar-itinerar-txt-8') }</p>
                          <p>{ t('zadar.zadar-itinerar-txt-9') }</p>
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <div>
                  <Button id="info" className="morebtn">{ t('zadar.zadar-title-6') }</Button>
                    <UncontrolledCollapse toggler="#info">
                      <Card>
                        <CardBody>
                           
                          <ul>
                            <li>{ t('zadar.zadar-info-txt-1') }</li>
                            <li>{ t('zadar.zadar-info-txt-2') }</li>
                            <li>{ t('zadar.zadar-info-txt-3') }</li>
                            <li>{ t('zadar.zadar-info-txt-4') }</li>
                            <li>{ t('zadar.zadar-info-txt-5') }</li>
                            <li>{ t('zadar.zadar-info-txt-6') }</li>
                            <li>{ t('zadar.zadar-info-txt-7') }</li>
                          </ul>
                          
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>
                <div>
                  <Button id="otkazivanje" className="morebtn">{ t('zadar.zadar-title-7') }</Button>
                    <UncontrolledCollapse toggler="#otkazivanje">
                      <Card>
                        <CardBody>
                           <p>
                          Bez ikakvih naknada možete promijeniti ili otkazati transfer ili izlet do 24 sata prije predviđenog početka. 
                          U slučaju da ste prisiljeni promijeniti Vaše planove zbog situacije s Covid-19  ( dobili ste pozitivan test) 
                          za manje od 24 sata prije predviđenog polaska, slobodno nas kontaktirajte te ćemo otkazati ili promijeniti vašu rezervaciju bez ikakvih naknada.
                          </p>
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <Kontaktizleti izlet="Zadar"/>

              </div>
          </div>
    </div>
  );
}

export default Zadar;

